const validation = (elements) => {
    let errors = {
        isValidated: true
    };
    if(!elements.Surname){
        errors.surname = "Surname is required";
        errors.isValidated = false;
    }
    if(!elements.Email){
        errors.email = "Email is required";
        errors.isValidated = false;
    }
    else if(!/\S+@\S+\.\S+/.test(elements.Email)){
        errors.email = "Email not valid";
        errors.isValidated = false;
    }
    if(!elements.OtherName){
        errors.otherNames = "Other Names are required";
        errors.isValidated = false;
    }
    if(!elements.PhoneNumber){
        errors.phoneNumber = "Phone Number is required";
        errors.isValidated = false;
    }
    if(!elements.MatricNo){
        errors.matricNum = "Matric Number is required";
        errors.isValidated = false;
    }
    else if(!/[a-zA-Z]{3}\/\d{2}\/\d{2}\/\d{6}/.test(elements.MatricNo)){
        errors.matricNum = "Matric Number is invalid";
        errors.isValidated = false;
    }

    if(!elements.LocationId){
        errors.campusLoc = "Select a valid option";
        errors.isValidated = false;
    }
    if(!elements.ServiceId){
        errors.service= "Select a valid option";
        errors.isValidated = false;
    }
    if(!elements.Department){
        errors.department = "Department is required";
        errors.isValidated = false;
    }
    if(!elements.PreferredTimeSlot){
        errors.timeSlot = "Select an option"
        errors.isValidated = false;
    }
    if(elements.Whatsapp === null){
        errors.numOnWhatsapp = "Select an option"
        errors.isValidated = false;
    }
    return errors;
}
export default validation;